import getWindow from './windowProvider';

// https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie#answer-21712356
// eslint-disable-next-line import/prefer-default-export
export function checkIfInternetExplorer() {
  return !!getWindow().document?.documentMode;
}
